module.exports = __webpack_public_path__ + "static/media/golist.52568568.png";